import type { VoidFunctionComponent } from 'react';

import FilterPanel from '../../generic/Filter/FilterPanel';
import Toggle from '../../generic/Toggle';
import { useExecutiveOptionsParams } from '../hooks/useExecutiveOptionsParams';

import styles from './ExecutiveVulnerabilityOptions.module.less';

const FULL_LIST_TOGGLE_ID = 'executive-vulnerability-full-list';

/**
 * Renders the options for the executive vulnerability report. State is managed via URL query params.
 */
export const ExecutiveVulnerabilityOptions: VoidFunctionComponent = () => {
  const [isFullList, setIsFullList] = useExecutiveOptionsParams();

  return (
    <FilterPanel title="Options">
      <div className={styles.toggle}>
        <Toggle id={FULL_LIST_TOGGLE_ID} checked={isFullList} onChange={setIsFullList} />
        <label htmlFor={FULL_LIST_TOGGLE_ID} className={styles.label}>
          Include Full Vulnerability List
        </label>
      </div>
    </FilterPanel>
  );
};
